/* @flow strict */

import * as React from 'react';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

type PropsType = {
  page: string
};

const Frame = ({ page }: PropsType): React.Element<'iframe'> => {
  const _context = React.useContext(DefaultContainerContext);

  if (!page) {
    return null;
  }

  const subDir = process.env.NODE_ENV === 'development' ? 'dev' : 'prod';
  // eslint-disable-next-line
  const pageURL = `/pages/preview/${subDir}/${page}.html?merchant_id=${_context.profileCurrent.id}&previewUrl=${_context.profileCurrent.website}&theme=${_context.profileCurrent.calendar_theme}`;

  return (
    <iframe
      style={{
        width: '100%',
        height: '100%'
      }}
      className='sp-client-iframe'
      src={pageURL}
    />
  );
};

export default Frame;